export default __webpack_public_path__ + "static/media/hald-sharp-donut.c68849e3.png";